import React, { useState } from 'react'
import styled from 'styled-components'
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import UploadFileRoundedIcon from '@mui/icons-material/UploadFileRounded'
import GenerateFormFromDocument, { FormGenButton } from './index'

const storageKey = obligationId => `formGen.tipDismissed.${obligationId}`

const readDismissed = obligationId => {
  try {
    return localStorage.getItem(storageKey(obligationId)) === '1'
  } catch (e) {
    return false
  }
}

const GenericFormTip = ({ obligationId, buildingPassportId }) => {
  const [dismissed, setDismissed] = useState(() => readDismissed(obligationId))
  if (dismissed || !obligationId || !buildingPassportId) return null

  const dismiss = () => {
    try {
      localStorage.setItem(storageKey(obligationId), '1')
    } catch (e) {}
    setDismissed(true)
  }

  return (
    <Tip data-testid='form-gen-generic-tip'>
      <LightbulbOutlinedIcon aria-hidden='true' />
      <Body>
        <span>Use your own checklist for this check? Upload it and we will turn it into a form.</span>
        <GenerateFormFromDocument
          buildingPassportId={buildingPassportId}
          targetType='programme_obligation'
          targetId={obligationId}
        >
          {open => (
            <FormGenButton type='button' onClick={open} data-tour-id='formGen.open.genericTip'>
              <UploadFileRoundedIcon aria-hidden='true' />
              <span>Use your own checklist</span>
            </FormGenButton>
          )}
        </GenerateFormFromDocument>
      </Body>
      <Dismiss type='button' aria-label='Hide this tip' onClick={dismiss}>
        <CloseRoundedIcon />
      </Dismiss>
    </Tip>
  )
}

export default GenericFormTip

const Tip = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 12px 12px 14px;
  margin-bottom: 16px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;

  > svg { font-size: 20px; color: #1f8b98; flex: 0 0 auto; margin-top: 2px; }
`

const Body = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  font-size: 15px;
  line-height: 1.45;
  color: #334155;
`

const Dismiss = styled.button`
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #475569;
  cursor: pointer;
  &:hover { background: #f1f5f9; }
  &:focus-visible { outline: 2px solid #33becc; outline-offset: 2px; }
`
